module.exports = __webpack_public_path__ + "static/img/timemoney.5bd9d6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/timemoney.png
// module id = 8YfQ
// module chunks = 1